import { MarkerClusterer } from '@googlemaps/markerclusterer'

const BRAND = import.meta.env.PUBLIC_APP_BRAND

const colors: { [key: string]: string } = {
  satch: '#007BC2',
  ergobag: '#50AFD7',
  affenzahn: '#22656c',
}

const strokeColor: { [key: string]: string } = {
  satch: '#007BC2',
  ergobag: '#50AFD7',
  affenzahn: '#000',
}

interface ClusterInterface {
  get count(): number
  get bounds(): google.maps.LatLngBounds | undefined
  position?: google.maps.LatLng | google.maps.LatLngLiteral
}

interface RendererInterface {
  render: (cluster: ClusterInterface) => google.maps.Marker
}

const renderer: RendererInterface = {
  render: (cluster) => {
    const clusterMarker = new google.maps.Marker({
      label: {
        text: String(cluster.count),
        color: 'white',
      },
      zIndex: cluster.count,
      position: cluster.position,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: colors[BRAND],
        fillOpacity: 1,
        scale: 24,
        strokeColor: strokeColor[BRAND],
        strokeOpacity: 0.8,
        strokeWeight: 2,
      },
    })

    return clusterMarker
  },
}

interface MarkerClusterInterface {
  map: google.maps.Map | undefined
  markers: google.maps.Marker[] | undefined
}

export const markerClusterer = ({ map, markers }: MarkerClusterInterface) =>
  new MarkerClusterer({
    map,
    markers,
    renderer,
    algorithmOptions: {
      maxZoom: 10,
      // @ts-ignore
      radius: 200,
    },
  })

interface CreateMarkerClusterProps {
  map: google.maps.Map | undefined
  markers: google.maps.Marker[] | undefined
}

export const createMarkerCluster = ({
  map,
  markers,
}: CreateMarkerClusterProps) => markerClusterer({ map, markers })
